<script lang="ts" setup>
import { stepper } from '@consumer/stores/recipientV2'
import { useRecipientLanding } from '@consumer/modules/recipientGiftLandingV2/composables'

const {
  isRedeemed,
  isRedemptionRequested,
  primaryBgColor,
  primaryTextColor,
} = useRecipientLanding()
</script>

<template>
  <div
    id="recipient-gift-landing-v2-hero"
    ref="heroRef"
    class="
      rounded-b-v2lg lg:rounded-v2lg
      p-0
      flex flex-col lg:flex-row justify-between
      w-full
      overflow-hidden
    "
    :class="[
      stepper.isBefore('REDEMPTION') ? 'h-[calc(100dvh_-_192px)] lg:h-[550px] relative' :
      (isRedeemed || isRedemptionRequested ? 'lg:min-h-[550px]' : 'lg:min-h-[550px]'),
    ]"
    :style="{
      color: primaryTextColor,
      backgroundColor: primaryBgColor,
    }"
  >
    <slot/>
  </div>
</template>
